export const showLoader = () => {
    const node : any = document.querySelector('.divSpinner');
    node.removeAttribute("style");
};

export const hideLoader = () => {
   const node : any = document.querySelector('.divSpinner');
   node.style.display = "none";
    };
